import React from 'react'

const Footer = () => {
  return (
    <div className='bg-gray-800 text-white p-4 h-32 fixed w-full bottom-0 left-0'>
      <h1>Explore the AAR</h1>
      <div className='flex justify-evenly m-4'>
        <p>asdfasdf</p>
        <p>asdfasdf</p>
        <p>asdfasdf</p>
        <p>asdfasdf</p>
        <p>asdfasdf</p>
      </div>
      <p >Copyright  &copy; 2024 All Rights Reserved.</p>
    </div>
  )
}

export default Footer